<template>
  <section id="mailbox-provider">
    <page-header
      class="mb-8"
      :breadcrumbs="breadcrumbs"
      :title="mailboxProvider"
    />
    <v-tabs
      v-model="activeTab"
      background-color="transparent"
      class="border-bottom-grey"
    >
      <v-tab
        class="px-12 subtitle-2 text-dark-grey font-weight-large"
        active-class="setting-active-tab"
        v-for="({ name, query, elementId }, i) in tabsName"
        :id="elementId"
        v-text="name"
        :key="i"
        @click="onTabChange(query, i)"
      >
      </v-tab>
    </v-tabs>
    <v-row class="d-flex justify-center">
      <v-col cols="12">
        <v-tabs-items v-model="activeTab" class="border-bottom-2 transparent">
          <v-tab-item v-for="itemComponent in tabItems" :key="itemComponent">
            <keep-alive>
              <component
                :is="itemComponent"
                :is-loading="isLoading"
                :mailbox-provider="mailboxProviderDetails"
                @set-provider-name="mailboxProvider = $event"
              />
            </keep-alive>
          </v-tab-item>
        </v-tabs-items>
      </v-col>
    </v-row>
  </section>
</template>

<script>
import TabsNavigator from "@/mixins/TabsNavigator.mixin";
import PageHeader from "@/components/shared/PageHeader.vue";
import MailboxProviderProfile from "./MailboxProviderProfile.vue";

import ManageSeeds from "@/views/ManageSeeds.vue";
import { getMailboxProvider } from "@/services";

/**
 * Mailbox provider show page
 */
export default {
  name: "MailboxProvider",
  /**
  |--------------------------------------------------
  | Mixins
  |--------------------------------------------------
  */
  mixins: [TabsNavigator],
  /**
  |--------------------------------------------------
  | Components
  |--------------------------------------------------
  */
  components: {
    PageHeader,
    ManageSeeds,
    MailboxProviderProfile,
  },
  /**
  |--------------------------------------------------
  | Data Properties
  |--------------------------------------------------
  */
  data() {
    return {
      mailboxProvider: "",
      mailboxProviderDetails: {},
      activeTab: 0,
      isLoading: false,
      tabsName: [
        {
          name: "Profile",
          query: "profile",
          elementId: "mailbox_provider_profile",
        },
        {
          name: "Seed List",
          query: "seeds",
          elementId: "seed",
        },
      ],
      tabItems: ["MailboxProviderProfile", "ManageSeeds"],
    };
  },
  /**
  |--------------------------------------------------
  | Computed properties
  |--------------------------------------------------
  */
  computed: {
    breadcrumbs() {
      return [
        {
          to: this.$paths.mailboxProviders,
          type: this.$appConfig.breadcrumbs.types.route,
          title: this.$dictionary.app.mailboxProvider.index.title,
        },
        {
          type: this.$appConfig.breadcrumbs.types.route,
          title: this.mailboxProvider,
        },
      ];
    },
  },
  /**
  |--------------------------------------------------
  | Methods
  |--------------------------------------------------
  */
  methods: {
    /**
     * Fetches details of a mailbox provider whose details are bein displayed
     * @todo Implement get mailbox provider details get api here
     */
    async getMailboxProviderDetails() {
      try {
        this.isLoading = true;
        const { id } = this.$route.params;
        const { data } = await getMailboxProvider(id);

        this.mailboxProviderDetails = data ?? {};
        this.mailboxProvider = data?.name ?? "";
      } finally {
        this.isLoading = false;
      }
    },
  },
  /**
  |--------------------------------------------------
  | Created lifecycle hook
  |--------------------------------------------------
  */
  created() {
    this.getMailboxProviderDetails();
  },
};
</script>
